// extracted by mini-css-extract-plugin
export default {"flexWrap":"R2zp6D5S5E50qGQRW53N"};
    if(module.hot) {
      // 1647894309253
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  